import { render, staticRenderFns } from "./DocumentThumbnail.vue?vue&type=template&id=bdb2e8b2&scoped=true"
import script from "./DocumentThumbnail.vue?vue&type=script&lang=js"
export * from "./DocumentThumbnail.vue?vue&type=script&lang=js"
import style0 from "./DocumentThumbnail.vue?vue&type=style&index=0&id=bdb2e8b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb2e8b2",
  null
  
)

export default component.exports